module.exports = __webpack_public_path__ + "media/images/applicant/attention-square-invalid-aaf866543fec65ebf00e8e0cde2f2592.svg";